import { ActionList, Button, ButtonProps, Popover } from "@shopify/polaris"
import React, { useMemo, useState } from "react"

export interface SelectedOption<T extends string | number> {
  label: string
  value: T
}
export interface ProSelectPopoverProps<T extends string | number> {
  options: SelectedOption<T>[]
  value?: T
  onChange?: (value: T) => void
  defaultText?: string
  buttonProps?: Omit<ButtonProps, "onClick">
}
function ProSelectPopover<T extends string | number>(
  props: ProSelectPopoverProps<T>,
) {
  const {
    options,
    value,
    onChange,
    defaultText,
    buttonProps = {
      disclosure: true,
    },
  } = props

  const optionMap = useMemo(() => {
    const result: Record<string, SelectedOption<T>> = {}
    options.forEach((item) => {
      result[item.value as string] = item
    })
    return result
  }, [options])

  const [popoverActive, setPopoverActive] = useState(false)
  return (
    <Popover
      active={popoverActive}
      activator={
        <Button
          {...buttonProps}
          onClick={() => setPopoverActive((popoverActive) => !popoverActive)}
        >
          {defaultText
            ? defaultText
            : (optionMap?.[value as string]?.label ?? "Please selected")}
        </Button>
      }
      autofocusTarget="none"
      onClose={() => setPopoverActive((popoverActive) => !popoverActive)}
    >
      <ActionList
        items={options.map((item) => {
          return {
            content: item.label,
            active: item.value === value,
            onAction() {
              onChange?.(item.value)
              setPopoverActive(false)
            },
          }
        })}
      />
    </Popover>
  )
}

export default ProSelectPopover
